export const PASS_PLACEMENT_SIDEPANEL_WIDTH = 280;
